import React from 'react';

const DashboardSummary = ({ summaryData }) => {
  // Use the pre-calculated summary data from the hook
  const stats = summaryData || { 
    pending: 0, 
    approved: 0, 
    withItinerary: 0, 
    upcoming: 0 
  };

  const summaryCards = [
    { 
      title: 'Pending Requests', 
      value: stats.pending, 
      color: 'bg-amber-50 text-amber-800 border-amber-200',
      icon: '⏳',
      description: 'Awaiting approval'
    },
    { 
      title: 'Approved Requests', 
      value: stats.approved, 
      color: 'bg-emerald-50 text-emerald-800 border-emerald-200',
      icon: '✅',
      description: 'Ready to proceed'
    },
    { 
      title: 'With Itinerary', 
      value: stats.withItinerary, 
      color: 'bg-blue-50 text-blue-800 border-blue-200',
      icon: '✈️',
      description: 'Travel booked'
    },
    { 
      title: 'Upcoming Travel', 
      value: stats.upcoming, 
      color: 'bg-purple-50 text-purple-800 border-purple-200',
      icon: '📅',
      description: 'Starting soon'
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {summaryCards.map((card) => (
        <div 
          key={card.title} 
          className={`relative overflow-hidden rounded-xl border-2 ${card.color} shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1`}
        >
          <div className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="text-3xl opacity-80">{card.icon}</div>
              <div className="text-right">
                <div className="text-3xl font-bold leading-none">{card.value}</div>
                <div className="text-xs opacity-75 mt-1">{card.description}</div>
              </div>
            </div>
            <h3 className="text-sm font-semibold">{card.title}</h3>
          </div>
          <div className="absolute top-0 right-0 w-20 h-20 bg-white bg-opacity-20 rounded-full -mr-10 -mt-10"></div>
        </div>
      ))}
    </div>
  );
};

export default DashboardSummary;